export default __webpack_public_path__ + "static/media/view4_year_province_place_cause_.02ed6f1e.csv";